'use client';

import type { ReactNode } from 'react';

import { cn } from '../../../../utils/entry.js';
import DrawCardPanel from '../../ChildComponents/DrawCard.Panel.js';

type DrawCardCloseTimeDesktopProps = {
  drawCardCloseTime: ReactNode;
  classNameHeader?: string;
  classNameValue?: string;
};

/**
 * Component that displays the close time of a draw in desktop view.
 *
 * @param props - The component props
 * @param props.drawCardCloseTime - The React node that displays the close time of the draw
 * @param props.classNameHeader - CSS class name for the header element
 * @param props.classNameValue - CSS class name for the value element
 * @returns A React node displaying the close time panel
 */
export default function DrawCardCloseTimeDesktop({
  drawCardCloseTime,
  classNameHeader,
  classNameValue,
}: DrawCardCloseTimeDesktopProps): ReactNode {
  return (
    <DrawCardPanel ariaLabel="Spelstopp" ariaLive="off" className={cn('hidden lg:flex')}>
      <div className={classNameHeader}>Spelstopp</div>
      <div className={classNameValue} data-testid="regCloseTime">
        {drawCardCloseTime}
      </div>
    </DrawCardPanel>
  );
}
